declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, SaveOTSectionDataRequest, FieldData, NewBillData, BillPaymentOption, SaveBillItemsInfoRequest, BillAdvanceByCodeController, BillAdvanceByCodeRequest, SaveRefundPayInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbActorDocsModal } from '../../profile/modals/actordocs/actordocs.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../../_MasterClasses/BillingClasses';
import { CodeTypeValueService } from '../../../../custumcomponents/codetypes/codetypevalue.service';
import { CodeTypeValue, CodeTypeRequest } from '../../../../custumcomponents/codetypes/codetypevalue.interface';
import { NgxSpinnerService } from 'ngx-spinner';
//import { NgbActorDocsModal } from '../../../../../../modals/actordocs/actordocs.modal';

@Component({
    selector: 'paymentrefund',
    templateUrl: './paymentrefund.modal.html',
    styleUrls: ['./paymentrefund.modal.scss']
})

export class NgbPaymentRefundModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    //@Input() ActorCode;
    @Input() TemplateName: string;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    @Input() PatientName: string;
    @Input() PatientImage: string;
    @Input() Age: string;
    @Input() Data: string;
    @Input() BillStatus2: string;
    @Input() Balance: number;
    @Input() Gender: string;
    @Input() Telephone1: string;
    @Input() BillDate: Date;
    @Input() TotalBill: number;
    @Input() TotalRefund: number;
    @Input() NetPayable: number;
    @Input() Discount: number;
    @Input() ActorCode: number;
    @Input() ChargeEntryCode: number;
    @Input() BillStatus: string;
    @Input() BillType: string;
    @Input() BillSource: string;
    @Input() BranchName: string;
    @Input() BranchCode: number;
    @Input() PatientCode: number;
    @Input() ItemsSelected: BillDetails[];
    @Input() Prescriber: PrescribingDoctor[];
    @Input() Refferal: ReferringDoctor[];
    public cash: boolean = false;
    public card: boolean = false;
    public cheque: boolean = false;
    public AdvanceSelected: boolean = false;
    public IsSelected2: boolean = false;
    public LNetPayable: number;
    public demanddraft: boolean = false;
    public paytm: boolean = false;
    public ChargeEntryNew: number;
    public CompanyCode: number;
    public AdvanceAmount: number = 0;
    public BillMode:string="NoAdvance"
    //@Input() FormattedCode: string;


    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    public ApiResData: ApiResponseModel;
    public ImageCode: number;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentActorAddEmergencyInfoRequest: SaveEmergencyContactInfoRequest;
    CurrentSaveOTSectionDataRequest: SaveOTSectionDataRequest;
    CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
    CurrentSaveRefundPayInfoRequest: SaveRefundPayInfoRequest;
    CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
    PatientDetails: PatientInfoByFormattedCodeController;
    CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
    LoadPatients() {
        this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

        //alert('Checking Forma ' + this.FormattedCode);
        this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
        this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
        this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
        this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
        this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
        this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

        this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetPatientInfoByFormattedCodeController();
    }
    GetPatientInfoByFormattedCodeController() {
        this.StartRefreshing();


        this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
                    this.PatientDetails = this.CurrentPatientInfoByFormattedCodeController[0];
                    //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();

                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, public printService: PrintService,
        private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
        private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
        private tosterservice: NGXToastrService, private modalService: NgbModal, private spinner: NgxSpinnerService, public codeTypeValueService: CodeTypeValueService) { }
    ngOnInit() {
        
        this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
        this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveRefundPayInfoRequest = new SaveRefundPayInfoRequest();
        this.CurrentSaveRefundPayInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
        this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
        this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
        this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
        this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.ShowService = false;
        this.CurrentSaveOTSectionDataRequest = new SaveOTSectionDataRequest();
        this.CurrentSaveOTSectionDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
       // this.LoadPatients();
        //this.LoadRegistries();
       // this.Addrow();
        this.InitPaymentoptions();
        

    }
    CurrentCodeTypeRequest: CodeTypeRequest;
    CurrentPaymentDetails: Array<BillPaymentOption>;
    PaymentTypes: CodeTypeValue[];
    InitPaymentoptions() {
        this.CurrentPaymentDetails = new Array<BillPaymentOption>();
        this.CurrentCodeTypeRequest = new CodeTypeRequest();
        this.CurrentCodeTypeRequest.CodeType = "PYTMD";
        this.CurrentCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

        this.GetPaymentTypes(this.CurrentCodeTypeRequest);
    }

    GetPaymentTypes(SendCodeTypeRequest: CodeTypeRequest): void {
        this.StartRefreshing();

        this.codeTypeValueService.GetCodeValuesByType(SendCodeTypeRequest).subscribe
            (
                (result) => {
                    this.ApiResData = result;
                    if (!this.ApiResData.hasError) {
                        //  console.log('GetActorProfileController');
                        this.PaymentTypes = this.ApiResData.Result;
                        for(let ptype of this.PaymentTypes){
                            var opt = new BillPaymentOption();
                            opt.Amount = 0;
                            opt.Charges = 0;
                            opt.Details = "";
                            opt.PaymentMode = ptype.LongValue;
                            opt.Refno = "";
                           
                            this.CurrentPaymentDetails.push(opt);
                        }
                        
                        this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        if (this.ApiResData.ErrorData != "") {

                            alert(this.ApiResData.ErrorData);
                        }
                        else {
                            alert(' Failed Due to Internal Error.... Please Contact Admin..');
                        }
                    }

                },
                //(ddlRefferedType) => {
                //    this.ddlRefferedType = ddlRefferedType;
                //    this.stopRefreshing();



                //},

                (error) => {

                    if (error == "401 - Unauthorized") {
                        // alert(error);
                        this.stopRefreshing();



                    }
                    else {
                        // alert(error);
                        this.stopRefreshing();
                    }
                }
            );;

    }
    LoadRegistries() {
        this.StartRefreshing();



        //this.GetBranchMap();


    }

    public number: number;
    unchecked(e, l: BillPaymentOption,i:number) {
        if (!e.target.checked) {
            l.Amount = 0;
           // this.LNetPayable = this.CurrentPaymentDetails.map(a => a.Amount).reduce(function (a, b) {
             //   return a + b;
            //});
           // this.LNetPayable = this.CurrentPaymentDetails.filter((l) => l.Amount)
             //  .map((l) => +l.Amount)
              //  .reduce((sum, current) => sum + current);
            if (i > 0) {
                this.LNetPayable = this.CurrentPaymentDetails.filter(item => item.Amount)
                    .map((item) => +item.Amount)
                    .reduce((sum, current) => sum + current);
            }
           
           // this.CurrentPaymentDetails.forEach(l => this.LNetPayable += l.Amount);
            if (i == 0) {
                this.LNetPayable = 0;
            }
           // alert(this.LNetPayable);
        }
    }
    checked2(e) {
        this.LoadAdvances(e);
      
    }
    
    CurrentBillAdvanceByCodeController: BillAdvanceByCodeController[];
    CurrentBillAdvanceByCodeRequest: BillAdvanceByCodeRequest;
    LoadAdvances(e) {   
        this.CurrentBillAdvanceByCodeRequest = new BillAdvanceByCodeRequest();
        // this.pdata = this.CurrentDoctorsListController;
        //this.pdata1 = this.CurrentDoctorsListController;
        this.CurrentBillAdvanceByCodeRequest.ConditionalOperator = 20;
        this.CurrentBillAdvanceByCodeRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentBillAdvanceByCodeRequest.PatientCode = this.PatientCode;
        this.CurrentBillAdvanceByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetBillAdvanceByCodeController(e);
    }
    GetBillAdvanceByCodeController(e) {
        this.StartRefreshing();
        this.spinner.show();
        this.actorservice.GetBillAdvanceByCodeController(this.CurrentBillAdvanceByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentBillAdvanceByCodeController = this.ApiResData.Result;
                    this.AdvanceAmount = this.CurrentBillAdvanceByCodeController[0].AdvanceAmount;
                    if (e.target.checked) {

                        this.BillMode = "UseAdvance";
                        if (this.AdvanceAmount > this.NetPayable) {

                            this.LNetPayable = this.NetPayable;
                            var opt = new BillPaymentOption();
                            opt.Amount = this.LNetPayable;
                            opt.Charges = 0;
                            opt.Details = "";
                            opt.PaymentMode = "Advance";
                            opt.Refno = "";
                            opt.IsSelected = true;
                            this.CurrentPaymentDetails.push(opt);

                        }
                        else if (this.AdvanceAmount < this.NetPayable) {
                            //alert("Adv2");
                            var opt = new BillPaymentOption();
                            opt.Amount = this.AdvanceAmount;
                            opt.Charges = 0;
                            opt.Details = "";
                            opt.PaymentMode = "Advance";
                            opt.Refno = "";
                            opt.IsSelected = true;
                            this.CurrentPaymentDetails.push(opt);
                            this.LNetPayable = this.CurrentPaymentDetails.filter(item => item.Amount)
                                .map((item) => +item.Amount)
                                .reduce((sum, current) => sum + current);
                           

                        }
                    }
                    else if (!e.target.checked) {
                        this.AdvanceAmount = 0;
                        this.LNetPayable = 0;
                        this.BillMode = "NoAdvance";
                        this.CurrentPaymentDetails.pop();
                        //var opt = new BillPaymentOption();
                        //opt.Amount = this.LNetPayable;
                        //opt.Charges = 0;
                        //opt.Details = "";
                        //opt.PaymentMode = "Advance";
                        //opt.Refno = "";
                        //opt.IsSelected = false;
                        //this.CurrentPaymentDetails.push(opt);

                    }
                    //this.pdata = this.CurrentServicesByCategoryCodeController;

                    this.stopRefreshing();
                    this.spinner.hide();
                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }


            );

    }
    netpayablesum(Caution: string) {
        if (Caution = 'add') {
            this.LNetPayable = this.CurrentPaymentDetails.filter((item) => item.Amount)
                .map((item) => +item.Amount)
               .reduce((sum, current) => sum + current);
           // this.LNetPayable = this.CurrentPaymentDetails.filter(l => l.Amount)
             //   .reduce((sum, current) => sum + current.Amount,0);
            //alert(this.LNetPayable);
        }
    }



    onSubmit() {

        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveOTSectionDataRequest.ConditionalOperator = 20;
        this.CurrentSaveOTSectionDataRequest.PatientReportCode = this.PatientReportCode;
        this.CurrentSaveOTSectionDataRequest.LastUpdateTime = new Date();
        this.CurrentSaveOTSectionDataRequest.SectionData = this.sectionData;
        this.actorservice.SaveOTFormDetail(this.CurrentSaveOTSectionDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.activeModal.close();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        this.activeModal.close();


                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

    }



    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    Paymenttype(paymentmode:string) {
       // alert(paymentmode);
    }
    
    
    //PaymentDetails: BillPaymentOption;
    
    CurrentNewBillData: NewBillData;
    AddData() {
        this.spinner.show();
        this.CurrentNewBillData = new NewBillData();
        this.CurrentNewBillData.ActorCode = this.ActorCode;
        this.CurrentNewBillData.BillDate = this.BillDate;
        this.CurrentNewBillData.BillSource = "Internal";
        this.CurrentNewBillData.BillStatus = "";
        this.CurrentNewBillData.BillType = "OP";
        this.CurrentNewBillData.BranchCode = this.BranchCode;
        this.CurrentNewBillData.BranchName = this.BranchName;
        this.CurrentNewBillData.ChargeEntryCode = this.ChargeEntryCode;
        this.CurrentNewBillData.Gender = this.Gender;
        this.CurrentNewBillData.Items = this.ItemsSelected;
        this.CurrentNewBillData.PrescriberDoctor = this.Prescriber;
        this.CurrentNewBillData.ReferringDoctor = this.Refferal;
        this.CurrentNewBillData.PatientFormattedCode = this.FormattedCode;
        this.CurrentNewBillData.PatientName = this.PatientName;
        this.CurrentNewBillData.PhoneNumber = this.Telephone1;
        this.CurrentNewBillData.TotalDiscount = 0;
        this.CurrentNewBillData.TotalBill = this.TotalBill;
        this.CurrentNewBillData.NetPayable = this.NetPayable;
        this.CurrentNewBillData.TotalRefund = this.TotalRefund;
        this.CurrentNewBillData.PayOptions = this.CurrentPaymentDetails.filter(
            function (a) {
                return a.IsSelected == true

            });

        this.SaveData();
    }
    //NetChange(Amount: number) {
    //   // alert(Amount);
    //    this.LNetPayable = this.LNetPayable - Amount;

    //}
    SaveData() {
       // alert(this.BillStatus2);
        //this.spinner.show();
        this.CurrentSaveRefundPayInfoRequest.RefundPay = this.CurrentNewBillData;
        this.CurrentSaveRefundPayInfoRequest.ChargeEntry = this.ChargeEntryCode.toString();
        this.CurrentSaveRefundPayInfoRequest.CompanyRefundCode = this.CompanyCode;
        this.CurrentSaveRefundPayInfoRequest.ConditionalOperator = 100;
        
         
        this.actorservice.SaveRefundPayInfo(this.CurrentSaveRefundPayInfoRequest)
            .subscribe((result) => {

                this.ApiResData = result;
                if (result.Result > 0) {
                    this.ChargeEntryNew = this.ApiResData.Result[0];
                    //if (!this.ApiResData.hasError) {

                    //   if (this.ApiResData.Result > 0) {
                    
                    // alert(this.LChargeEntryCode);
                    //this.GetActorEducationInfoController();
                    //this.GetResourceIdentificationByDateInfoController();
                    // alertFunctions.AlertParam('Saved Successfully.....!');
                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.activeModal.close(this.ChargeEntryNew);
                    // this.Listview = true;
                    //this.EditEmbryo = false;
                    //this.LoadStoreData();
                    //this.AddEmbryo = false;
                    //this.spinner.hide();
                    //this.activeModal.close();
                    //this.clearData();
                    // this.LoadScansData();
                    this.stopRefreshing();
                    this.spinner.hide();
                }
                else {
                    alertFunctions.AlertParam("Invalid Operation :- " + "...!");

                    //this.spinner.hide();
                    this.stopRefreshing();
                    this.spinner.hide();
                }

            },





                (error) => {
                    // alert("kkhkhjkhkjhjkh");

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    Close() {
        this.activeModal.close(0);
    }
    SaveData2() {
        // alert(this.BillStatus2);
        //this.spinner.show();
        this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
        this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.ChargeEntryCode.toString();
        if (this.BillMode == 'NoAdvance') {
            this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 20;
        }
        else if (this.BillMode == 'UseAdvance') {
            this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 200;
        }


        this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
            .subscribe((result) => {

                this.ApiResData = result;
                if (result.Result[0].Result > 0) {
                    this.ChargeEntryNew = this.ApiResData.Result[0].Result;
                    //if (!this.ApiResData.hasError) {

                    //   if (this.ApiResData.Result > 0) {

                    // alert(this.LChargeEntryCode);
                    //this.GetActorEducationInfoController();
                    //this.GetResourceIdentificationByDateInfoController();
                    // alertFunctions.AlertParam('Saved Successfully.....!');
                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.activeModal.close(this.ChargeEntryNew);
                    // this.Listview = true;
                    //this.EditEmbryo = false;
                    //this.LoadStoreData();
                    //this.AddEmbryo = false;
                    //this.spinner.hide();
                    //this.activeModal.close();
                    //this.clearData();
                    // this.LoadScansData();
                    this.stopRefreshing();
                    this.spinner.hide();
                }
                else {
                    alertFunctions.AlertParam("Invalid Operation :- " + "...!");
                    this.spinner.hide();
                    this.stopRefreshing();
                   
                }

            },





                (error) => {
                    // alert("kkhkhjkhkjhjkh");

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                         this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                         this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
}




//export class BillPaymentOption {
//    public PaymentMode: string;

//    public Amount: string;
//    public Charges: string;
//    public Refno: string;
//    public Details: string;
//}
